const STORAGE_KEY = "campaign_categories_by_id";

function readStorage() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    console.error("Erro ao ler categorias de campanhas:", error);
    return {};
  }
}

function writeStorage(data) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Erro ao salvar categorias de campanhas:", error);
  }
}

export function getStoredCampaignCategory(campaignId) {
  if (!campaignId) return "";

  const data = readStorage();
  return data[String(campaignId)] || "";
}

export function setStoredCampaignCategory(campaignId, category) {
  if (!campaignId || !category) return;

  const data = readStorage();
  data[String(campaignId)] = category;
  writeStorage(data);
}
